import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodApplePayDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4134_559)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z",
				fill: "url(#paint0_linear_4134_559)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 0.25H44C46.0711 0.25 47.75 1.92893 47.75 4V28C47.75 30.0711 46.0711 31.75 44 31.75H4C1.92893 31.75 0.25 30.0711 0.25 28V4C0.25 1.92893 1.92893 0.25 4 0.25Z",
				stroke: "white",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip1_4134_559)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M12.5814 10.9055C12.1595 11.4047 11.4845 11.7984 10.8095 11.7422C10.7251 11.0672 11.0556 10.35 11.4423 9.90703C11.8642 9.39375 12.6025 9.02813 13.2001 9C13.2704 9.70312 12.9962 10.3922 12.5814 10.9055ZM13.1931 11.8758C12.2157 11.8195 11.379 12.4312 10.915 12.4312C10.4439 12.4312 9.73371 11.9039 8.96027 11.918C7.95481 11.932 7.01965 12.5016 6.50637 13.4086C5.45168 15.2227 6.23215 17.9086 7.25168 19.3852C7.7509 20.1164 8.34856 20.918 9.13606 20.8898C9.88137 20.8617 10.1767 20.4047 11.0767 20.4047C11.9837 20.4047 12.2439 20.8898 13.0314 20.8758C13.847 20.8617 14.3603 20.1445 14.8595 19.4133C15.429 18.5836 15.6611 17.775 15.6751 17.7328C15.6611 17.7188 14.1001 17.1211 14.0861 15.3211C14.072 13.8164 15.3165 13.0992 15.3728 13.057C14.6696 12.0164 13.5728 11.9039 13.1931 11.8758ZM18.8392 9.83672V20.7984H20.5407V17.0508H22.8962C25.0478 17.0508 26.5595 15.5742 26.5595 13.4367C26.5595 11.2992 25.0759 9.83672 22.9525 9.83672H18.8392ZM20.5407 11.2711H22.5025C23.979 11.2711 24.8228 12.0586 24.8228 13.4437C24.8228 14.8289 23.979 15.6234 22.4954 15.6234H20.5407V11.2711ZM29.6673 20.8828C30.7361 20.8828 31.7275 20.3414 32.1775 19.4836H32.2126V20.7984H33.7876V15.3422C33.7876 13.7602 32.522 12.7406 30.5743 12.7406C28.7673 12.7406 27.4314 13.7742 27.3821 15.1945H28.915C29.0415 14.5195 29.6673 14.0766 30.5251 14.0766C31.5657 14.0766 32.1493 14.5617 32.1493 15.4547V16.0594L30.0259 16.1859C28.0501 16.3055 26.9814 17.1141 26.9814 18.5203C26.9814 19.9406 28.0853 20.8828 29.6673 20.8828ZM30.1243 19.582C29.2173 19.582 28.6407 19.1461 28.6407 18.4781C28.6407 17.7891 29.1962 17.3883 30.2579 17.325L32.1493 17.2055V17.8242C32.1493 18.8508 31.2775 19.582 30.1243 19.582ZM35.89 23.7797C37.5493 23.7797 38.3298 23.1469 39.0118 21.2273L42.0001 12.8461H40.2704L38.2665 19.3219H38.2314L36.2275 12.8461H34.4486L37.3314 20.8266L37.1767 21.3117C36.9165 22.1344 36.4946 22.4508 35.7423 22.4508C35.6087 22.4508 35.3486 22.4367 35.2431 22.4227V23.7375C35.3415 23.7656 35.7634 23.7797 35.89 23.7797Z",
					fill: "white"
				})
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4134_559",
			x1: 0,
			y1: 0,
			x2: 48,
			y2: 32,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "white",
				stopOpacity: .04
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white",
				stopOpacity: .16
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4134_559",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 32,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_4134_559",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 36,
				height: 14.7797,
				fill: "white",
				transform: "translate(6 9)"
			})
		})
	] })]
});
export default SvgPaymentMethodApplePayDark;
